import '@fontsource-variable/atkinson-hyperlegible-next';
import '@fontsource-variable/atkinson-hyperlegible-mono';
import './styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ApiError, setUnauthorizedHandler } from './lib/api';
import { forgetSession } from './lib/session';
import { applyTheme, readPreference, resolveTheme, systemPrefersDark } from './lib/theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      // Un 4xx es una respuesta definitiva: reintentar no cambia nada.
      retry: (failures, error) => !(error instanceof ApiError && error.status < 500) && failures < 2,
    },
  },
});

// 401 en cualquier petición: la sesión expiró o se revocó. Se olvida todo lo local.
setUnauthorizedHandler(() => forgetSession(queryClient));

// Tema antes del primer render, para no parpadear en claro (la zona del perfil llega con la sesión).
applyTheme(resolveTheme(readPreference(), systemPrefersDark(), new Date()));

const root = document.getElementById('root');
if (!root) throw new Error('Falta #root en index.html');
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
